import { format, parseISO } from "date-fns";
import { DataGridTable } from "@shared/ui/DataGridTable";
import { dollarUS } from "@shared/utils/moneyFormat";

import type { GridColDef } from "@mui/x-data-grid";
import type { TFunction } from "i18next";
import type { CommissionPayment } from "../api/commissionApi";

export interface ReferredCommissionSummaryProps {
  data?: CommissionPayment[];
  t: TFunction;
  language?: string;
}

export const ReferredCommissionSummary = ({ data, t, language }: ReferredCommissionSummaryProps) => {
  const columns: GridColDef[] = [
    {
      field: "createdAt",
      headerName: t("date"),
      flex: 1,
      valueFormatter: (value: string | null) =>
        value == null ? "" : format(parseISO(value), "dd/MM/yyyy"),
    },
    { field: "candidateName", headerName: t("name"), flex: 1 },
    { field: "candidateLastname", headerName: t("lastname"), flex: 1 },
    { field: "candidateEmail", headerName: t("email"), flex: 1 },
    { field: "vacancyName", headerName: t("vacancy"), flex: 1 },
    {
      field: "amount",
      headerName: t("commissionAmount"),
      flex: 1,
      valueFormatter: (value: number | null) => (value == null ? "" : dollarUS.format(value)),
    },
  ];

  return (
    <DataGridTable
      rows={data}
      columns={columns}
      title={t("referenced")}
      language={language}
      search={false}
      download={false}
      filter={false}
    />
  );
};
